import { defineStore } from 'pinia';
import axios from 'axios';

// Education Systems admin store — manages the lookup list (name/active/order) that
// RegistrationFormSettingsModal's "Available Education Systems" section builds on.
export const useEducationSystemStore = defineStore('educationSystems', {
    state: () => ({
        systems: [],
        loading: false,
        saving: false,
    }),

    actions: {
        async fetchSystems() {
            this.loading = true;
            try {
                const { data } = await axios.get('/admin/education-systems');
                this.systems = data.data ?? [];
                return this.systems;
            } finally {
                this.loading = false;
            }
        },

        async createSystem(payload) {
            this.saving = true;
            try {
                const { data } = await axios.post('/admin/education-systems', payload);
                this.systems.push(data.data);
                return data.data;
            } finally {
                this.saving = false;
            }
        },

        async updateSystem(id, payload) {
            this.saving = true;
            try {
                const { data } = await axios.put(`/admin/education-systems/${id}`, payload);
                this.replaceLocal(data.data);
                return data.data;
            } finally {
                this.saving = false;
            }
        },

        async toggleSystem(id) {
            const { data } = await axios.patch(`/admin/education-systems/${id}/toggle`);
            this.replaceLocal(data.data);
            return data.data;
        },

        async deleteSystem(id) {
            await axios.delete(`/admin/education-systems/${id}`);
            this.systems = this.systems.filter(s => s.id !== id);
        },

        replaceLocal(system) {
            const idx = this.systems.findIndex(s => s.id === system.id);
            if (idx !== -1) this.systems[idx] = system;
        },
    },
});
